import React from 'react'
import {Flex} from '/app/src/component'
import { Route, Switch  } from 'react-router'
import {AdminComponent, ManagerComponent, withErrorBoundary} from  '/app/src/hoc'

import CompanySettings from './CompanySettings/'
import Conversation from './Conversation'
import User from './UserRoute'
import ClientChatSettings from './ClientChatSettings'
import ChatSettings from './ChatSettings'
import History from './History'
import Overview from './Overview'
import { SearchCustomer, SearchTicket } from './Search';

import Tutorial from './Tutorial'


class MainPanel extends React.Component {
    render(){
        return (
            <Flex basis='100%'>
                <Switch>
                    <Route key='companySettings' path='/companySettings' component={AdminComponent(CompanySettings)}/>

                    <Route key='clientChat' path='/clientChat'
                        component={withErrorBoundary(ManagerComponent(ClientChatSettings))}
                    />
                    <Route key='chatSettings' path='/chatSettings'
                        component={withErrorBoundary(ManagerComponent(ChatSettings))}
                    />

                    <Route key='history' path='/history'
                        component={withErrorBoundary(History)}
                    />
                    <Route path='/searchTicket'
                        component={withErrorBoundary(SearchTicket)}
                    />
                    <Route path='/searchCustomer'
                        component={withErrorBoundary(SearchCustomer)}/>
                    <Route path='/user'
                        component={withErrorBoundary(User)}
                    />
                    <Route path='/conversation'
                        component={withErrorBoundary(Conversation)}/>
                    <Route path='/tutorial'
                        component={withErrorBoundary(Tutorial)}/>
                    <Route
                        component={withErrorBoundary(Overview)}/>
                </Switch>
            </Flex>
        )
    }
}

export default MainPanel



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/index.js